import {defineStore} from 'pinia'
import {useHttpStore} from '@/stores';
import { computed,ref } from 'vue';
const baseUrl = `users`;
export const idPrefix = 'preset-id';
/**
 * defines entrance settings for user: allowed lift group {id,name}, preferred_floor, preferred_lift_id, lobby_floor 
 */
export const useEntrancesStore = defineStore('entrances',()=>{
        /**
         *  users :[
         * {userId:id,
         * entrances:[]}
         * ]
         *  */
        const users = ref([]); 
        // const curEntrance = null;
        const httpStore = useHttpStore();
        const newPresetId = ref(0);
        const curEntrance = ref({});
        const selU = ref(null); // selected user idx
        const selE = ref(null); // selected entrance idx

        // initialize state from local storage to enable user to stay logged in
        /**
         * 
         * @param {*} userId 
         */
        async function get(userId){
            userId = userId || 'me';
            let item = users.value.find(i=>i.userId===userId);
            let lg = item?item.entrances:null;
            if (!lg) {
                const res = await httpStore.get(`${baseUrl}/${userId}/groups`);
                users.value.push({userId: userId, entrances: res});
                lg = res;
            }
            return lg;
        }
        /**
         * 
         * @param {*} userId - user id to grant the entrance 
         * @param {*} entrance - entrance object {} 
         */
        async function add(userId, entrance) {
            // const httpStore = useHttpStore();
            userId = userId || 'me';
            const res = await httpStore.post(`${baseUrl}/${userId}/groups`,entrance)
            if (res) {
                const userItem = users.value.find(i=>i.userId == userId);
                if (userItem) {
                    userItem.entrances.push(res);
                }
                else {
                    users.value.push({userId:userId,entrances:res});
                }
            } 
            return res;
        }

        /**
         * 
         * @param {*} userId - user id for update
         * @param {*} entranceId - entrance id to update
         * @param {*} data - entrance data
         */
        const update = async (userId, entranceId, data)  =>  {
            userId = userId || 'me';
            const res = await httpStore.patch(`${baseUrl}/${userId}/groups/${entranceId}`, data);
            if (res) { //update entrance object in store
                selU.value = selE.value = null;
                const idxU = users.value.findIndex(i=>i.userId === userId);
                if (idxU>=0) {
                    selU.value = idxU;
                    const idxG = users.value[idxU].entrances.findIndex(g=>g.group.id===entranceId);
                    if (idxG>=0) {
                        selE.value = idxG;
                        users.value[idxU].entrances[idxG] = res;
                    }
                }
                return true;
            } else {
                return false;
            }
        }

        /**
         * 
         * @param {*} userId - user which entrance shoul be deleted
         * @param {*} entranceId - entranceId to be deleted
         */
        const del = async(userId, entranceId) => {
            userId = userId || 'me';
            const res = await httpStore.del(`${baseUrl}/${userId}/groups/${entranceId}`);
            if (res) { //remove  entrance object from store
                selU.value = selE.value = null;
                const idxU = users.value.findIndex(i=>i.userId === userId);
                if (idxU>=0) {
                    const idxG = users.value[idxU].entrances.findIndex(g=>g.group.id===entranceId);
                    if (idxG>=0) {
                        users.value[idxU].entrances.splice(idxG,1);
                        if (!users.value[idxU].entrances.length) {
                            users.value.splice(idxU,1);                        } 
                    }
                }
                return true;
            } else {
                return false;
            }
        }

        const clear=(clearUsers=false)=>{
            if (clearUsers) {
                users.value = [];
            }
            curEntrance.value = null;
            selU.value = selE.value = null;
        } 

        const select = (userId,entranceId)=>{
            userId = userId || 'me';
            selU.value = users.value.findIndex(i=>i.userId === userId);
            if (selU.value >=0 ) {
                selE.value = users.value[selU.value].entrances.findIndex(g=>g.group.id===entranceId);
                curEntrance.value = users.value[selU.value].entrances[selE.value];
            }
        }

        /**
         * Delete preset from curEntrance
         * @param {*} userId 
         * @param {*} entranceId 
         * @param {*} presetId 
         */
        const deletePreset = (presetId) => {
            if (!curEntrance.value) {
            } else {
                const idx = curEntrance.value.presets.findIndex(p=>p.id===presetId);
                if (idx>=0) {
                    curEntrance.value.presets.splice(idx,1);
                    if (!presetId.startsWith(idPrefix)) {
                        // entrancesStore.deletePreset(userId.value, groupId.value, presetId);
                        console.log("deleting preset in DB");
                    }
                }
                }
        }
        
        /**
         * add new empty preset to curEntrance if no one empty exists
         */
        const addPreset = () => {
            const ce = curEntrance;
            console.log("add common floor", curEntrance.value);
            const hasEmptyRow = curEntrance.value.presets.find(p=>p.name=="" || !p.floor);
            if (!hasEmptyRow) {
                curEntrance.value.presets.push({
                    id:`${idPrefix}${newPresetId.value++}`,
                    name:"",
                    isEditable: true,
                    floor:null,
                })
            }
        
        }
        return {curEntrance,  add, get, update, del, clear, addPreset, deletePreset, select};
    }
);